import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MessageType, SystemMessageTemplate } from '@/types/system-message-templates';
import { getAccessToken } from '@/lib/supabase';
import toast from 'react-hot-toast';

async function resetSystemMessageTemplate(messageType: MessageType): Promise<SystemMessageTemplate> {
  const token = await getAccessToken();

  if (!token) {
    throw new Error('Not authenticated');
  }

  const response = await fetch(`/api/system-message-templates/${messageType}/reset`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to reset template');
  }

  return response.json();
}

export function useResetSystemMessageTemplate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: resetSystemMessageTemplate,
    onError: (error) => {
      toast.error(error.message || 'Failed to reset template');
    },
    onSuccess: () => {
      toast.success('Template reset to default');
      // Invalidate queries to refetch updated data
      queryClient.invalidateQueries({ queryKey: ['system-message-templates'] });
    },
  });
}
